import appStrings from "./appStrings";
import countryList from "./countryList";
import jobFunctionList from "./jobFunctionList";
import nhrcbook from "./nhrcbook";
export default { appStrings, countryList, jobFunctionList, nhrcbook };
